export const HOME = {
  emergentLink: "emergent-link",
  searchInput: "search-input",
  searchButton: "search-button",
  searchForm: "search-form",
  filterBar: "filter-bar",
  filterLanguage: "filter-language",
  filterCountry: "filter-country",
  filterSize: "filter-size",
  filterType: "filter-type",
  filterColor: "filter-color",
  filterTime: "filter-time",
  clearFilters: "clear-filters-btn",
  imageGrid: "image-grid",
  imageCard: "image-card",
  paginationPrev: "pagination-prev",
  paginationNext: "pagination-next",
  paginationPage: "pagination-page",
  jsonToggle: "json-toggle-btn",
  jsonPanel: "json-panel",
  jsonCopy: "json-copy-btn",
  resultCount: "result-count",
  loadingIndicator: "loading-indicator",
  errorMessage: "error-message",
  emptyState: "empty-state",
};
